import { createFeatureSelector, createSelector } from "@ngrx/store";
import { SharedState } from "../reducers";


export const selectSharedState = createFeatureSelector<SharedState>('sharedConfig');

export const getConfig = createSelector(
    selectSharedState,
    (state) => state?.config_details
)


export const getBrands = createSelector(
    selectSharedState,
    (state) => state?.header_brands_list
)
